import React, { useEffect, useState,useContext } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';

const apiUrl = process.env.REACT_APP_API_URL;

const CheckoutPage = () => {
  const [htmlSnippet, setHtmlSnippet] = useState('');
  const [error, setError] = useState('');


  useEffect(() => {
    const klarna_order_id= localStorage.getItem('klarna_order_id');
    if (klarna_order_id) {
      axios.get(apiUrl+`/checkout/${klarna_order_id}`)
        .then(response => {
          const data = response.data;
          if (data.html_snippet) {
            setHtmlSnippet(data.html_snippet);
          } else {
            setError('Failed to load the checkout page. Please try again.');
            localStorage.removeItem('klarna_order_id');
          }
        })
        .catch(error => {
          console.error('Error:', error);
          setError('Failed to load the checkout page. Please try again.');
          localStorage.removeItem('klarna_order_id');
        });
    } else {
      setError('Your Orders  not found. Please start the checkout process again.');
      localStorage.removeItem('klarna_order_id');
    }
  }, []);
  useEffect(() => {
    if (htmlSnippet) {
      const checkoutContainer = document.getElementById('checkout-container');
      checkoutContainer.innerHTML = htmlSnippet;

      const scriptTags = checkoutContainer.getElementsByTagName('script');
      for (let i = 0; i < scriptTags.length; i++) {
        const parentNode = scriptTags[i].parentNode;
        const newScriptTag = document.createElement('script');
        newScriptTag.type = 'text/javascript';
        if (scriptTags[i].src) {
          newScriptTag.src = scriptTags[i].src;
        } else {
          newScriptTag.text = scriptTags[i].text;
        }
        parentNode.replaceChild(newScriptTag, scriptTags[i]);
      }
    }
  }, [htmlSnippet]);
  
  return (
    <>
     {error ? (
    <Box mt='25vh'ml='5%' sx={{width:'100%', flexDirection:'column',display:'flex'}}>
      
      <h1>Checkout</h1>
     
        <p>{error}</p>
        </Box>) : (<Box mt='15vh' >
        <div id="checkout-container"></div> 
        </Box>)
        
        }
    
    </>
   
  );
};

export default CheckoutPage;